import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";
import {
  getDetectionRequest,
  patchDetectionRequest,
  Detection,
  listDetectionsRequest,
  listDetectionsResponse,
} from "../../types";

export const detectionApi = createApi({
  reducerPath: "detectionApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["detection"],
  endpoints: (builder) => ({
    getDetection: builder.query<Detection, getDetectionRequest>({
      query: ({ id }) => ({
        url: `/detection/${id}`,
        method: "GET",
      }),
      providesTags: ["detection"],
      onQueryStarted: withErrorNotification("Failed to fetch detection"),
    }),
    listDetections: builder.query<
      listDetectionsResponse,
      listDetectionsRequest
    >({
      query: ({
        page = 0,
        pageSize = 10,
        invasive = false,
        bySpecimen = true,
        trap_site_id = "",
      }) => ({
        url: `/detections?page=${page}&pageSize=${pageSize}&invasive=${invasive}&bySpecimen=${bySpecimen}&trap_site_id=${trap_site_id}`,
        method: "GET",
      }),
      providesTags: ["detection"],
      onQueryStarted: withErrorNotification("Failed to fetch detections"),
    }),
    patchDetection: builder.mutation<Detection, patchDetectionRequest>({
      query: ({ id, data }) => ({
        url: `/detection/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["detection"],
      onQueryStarted: withErrorNotification("Failed to update detection"),
    }),
  }),
});

export const {
  useGetDetectionQuery,
  usePatchDetectionMutation,
  useListDetectionsQuery,
} = detectionApi;
